(function () {
  'use strict';

  angular.module('sempraWebapp').config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('login', {
        url: '/login',
        templateUrl: 'app/login/login.html',
        controller: 'LoginController',
        controllerAs: 'vm'
      })
      .state('activateAccount', {
        url: '/accountActivation/:code',
        templateUrl: 'app/activateAccount/activateAccount.html',
        controller: 'ActivateAccountController',
        controllerAs: 'vm'
      })
      .state('resetPassword', {
        url: '/resetPassword/:code',
        templateUrl: 'app/resetPassword/resetPassword.html',
        controller: 'ResetPasswordController',
        controllerAs: 'vm'
      })
      .state('activationSuccess', {
        url: '/activationSuccess',
        templateUrl: 'app/activateAccount/activationSuccess.html',
        controller: 'ActivationSuccessController',
        controllerAs: 'vm'
      })
      .state('forgotPassword', {
        url: '/forgotPassword',
        templateUrl: 'app/forgotPassword/forgotPassword.html',
        controller: 'ForgotPasswordController',
        controllerAs: 'vm'
      })
      .state('app', {
        url: '',
        abstract: true,
        templateUrl: 'app/layout/layout.html',
        data: {
          displayName: '{{crumb.value}}'
          //breadcrumbProxy :'app.dashboardTechnology'
        },
        resolve: {
          crumb: function ($translate) {
            return {
              value: $translate.instant('ASIDE_MENU_DASHBOARD_TECHNOLOGY')
            };
          },
          refreshToken: function (
            $q,
            sessionData,
            jwtHelper,
            userActions,
            broker,
            mqttBrokerIp,
            mqttBrokerPort,
            useMqttBrokerSsl,
            $state,
            $timeout
          ) {
            var token = sessionData.getValue(sessionData.Keys.ACCESS_TOKEN_KEY);
            if (token === 'null' || token === null || !token) {
              $timeout(function () {
                sessionData.clearAll();
                $state.go('login');
              });
            }
            var refreshToken = sessionData.getValue(
              sessionData.Keys.REFRESH_TOKEN_KEY
            );

            if (token && refreshToken) {
              var isTokenExpired = jwtHelper.isTokenExpired(token, 1);
              var isRefreshTokenExpired = jwtHelper.isTokenExpired(
                refreshToken,
                1
              );

              if (isTokenExpired && !isRefreshTokenExpired) {
                userActions.refreshToken().then(function (data) {
                  // reconnect web sockets
                  broker.initWebSockets(
                    mqttBrokerIp,
                    mqttBrokerPort,
                    useMqttBrokerSsl
                  );
                  token = data.data.accessToken;
                });
              }

              if (isRefreshTokenExpired) {
                $timeout(function () {
                  sessionData.clearAll();
                  $state.go('login');
                });
              }
            }
            return {
              accessToken: token
            };
          }
        },
        controller: 'LayoutController',
        controllerAs: 'vm'
      })
      .state('app.dashboardTechnology', {
        url: '/facilities',
        views: {
          'layoutPageContainer@app': {
            templateProvider: [
              'brand',
              '$state',
              '$templateRequest',
              function (brand, $state, $templateRequest) {
                var page;
                switch (brand) {
                  case 'karcher':
                    page =
                      'app/dashboardKarcherTechnology/dashboardKarcherTechnology.html';
                    return $templateRequest(page);

                  case 'r2w':
                    page = 'app/dashboardTechnology/dashboardTechnology.html';
                    return $templateRequest(page);
                }
              }
            ],
            controllerProvider: [
              'brand',
              function (brand) {
                switch (brand) {
                  case 'karcher':
                    return 'DashboardKarcherTechnologyController';

                  case 'r2w':
                    return 'dashboardTechnologyController';
                }
              }
            ],
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return {
              value: $translate.instant('ASIDE_MENU_DASHBOARD_TECHNOLOGY')
            };
          }
        }
      })
      .state('app.dashboardTechnology.siteDetails', {
        url: '/site/:id/:siteAddress/:siteLatitude/:siteLongitude',
        views: {
          'layoutPageContainer@app': {
            templateProvider: [
              'brand',
              '$state',
              '$templateRequest',
              function (brand, $state, $templateRequest) {
                var page;
                switch (brand) {
                  case 'karcher':
                    page =
                      'app/dashboardKarcherTechnology/siteDetails/siteDetails.html';
                    return $templateRequest(page);
                  case 'r2w':
                    page = 'app/errorPage/errorPage.html';
                    return $templateRequest(page);
                }
              }
            ],
            controllerProvider: [
              'brand',
              function (brand) {
                switch (brand) {
                  case 'karcher':
                    return 'SiteDetailsController';
                  case 'r2w':
                    return 'ErrorPageController';
                }
              }
            ],
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('SITE_DETAILS') };
          }
        }
      })
      .state('app.dashboardTechnology.siteDetails.facilityDetails', {
        url: '/device/:deviceId',
        views: {
          'layoutPageContainer@app': {
            templateUrl:
              'app/facilityKarcherDetails/facilityKarcherDetails.html',
            controller: 'FacilityKarcherDetailsController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('FACILITY_DETAILS') };
          }
        }
      })
      .state('app.dashboardFinancial', {
        url: '/dailyFinances',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/dashboardFinances/dashboardFinances.html',
            controller: 'dashboardFinancesController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return {
              value: $translate.instant('ASIDE_MENU_DASHBOARD_FINANCIAL')
            };
          }
        }
      })
      .state('app.dashboardTechnology.facilityDetails', {
        url: '/:id',
        views: {
          'layoutPageContainer@app': {
            templateProvider: [
              'brand',
              '$state',
              '$templateRequest',
              function (brand, $state, $templateRequest) {
                var page;
                switch (brand) {
                  case 'r2w':
                    page = 'app/facilityDetails/facilityDetails.html';
                    return $templateRequest(page);
                  case 'karcher':
                    page = 'app/errorPage/errorPage.html';
                    return $templateRequest(page);
                }
              }
            ],
            controllerProvider: [
              'brand',
              function (brand) {
                switch (brand) {
                  case 'r2w':
                    return 'FacilityDetailsController';
                  case 'karcher':
                    return 'ErrorPageController';
                }
              }
            ],
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('BREAD_CRUMBS_DETAILS') };
          }
        }
      })
      .state('app.dashboardTechnology.facilityDetails.facilitySettings', {
        url: '/settings',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/settings/settings.html',
            controller: 'SettingsController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('BREAD_CRUMBS_SETTINGS') };
          }
        }
      })
      .state('app.dashboardTechnology.facilityDetails.facilityWorkingHours', {
        url: '/:pointId/working-hours',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/workingHours/workingHours.html',
            controller: 'WorkingHoursController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('BREAD_CRUMBS_WORKING_HOURS') };
          }
        }
      })
      .state('app.dashboardTechnology.facilityDetails.servicePage', {
        url: '/service',
        params: {
          facility: null
        },
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/karcherService/karcherService.html',
            controller: 'KarcherServiceController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('BREAD_CRUMBS_SERVICE') };
          }
        }
      })
      .state('app.alarms', {
        url: '/alarms',
        views: {
          'layoutPageContainer@app': {
            templateProvider: [
              'brand',
              '$templateRequest',
              function (brand, $templateRequest) {
                var page;
                switch (brand) {
                  case 'karcher':
                    page = 'app/alarmsKarcher/alarmsKarcher.html';
                    return $templateRequest(page);
                  default:
                    page = 'app/alarms/alarms.html';
                    return $templateRequest(page);
                }
              }
            ],
            controllerProvider: [
              'brand',
              function (brand) {
                switch (brand) {
                  case 'karcher':
                    return 'KarcherAlarmsController';
                  default:
                    return 'AlarmsController';
                }
              }
            ],
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_ALARMS') };
          }
        }
      })
      .state('app.alarms.subscriptions', {
        url: '/subscriptions',
        views: {
          'layoutPageContainer@app': {
            templateUrl:
              'app/alarmsKarcher/alarmSubscriptions/alarmSubscriptions.html',
            controller: 'KarcherAlarmSubscriptionsController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('SUBSCRIPTIONS') };
          }
        }
      })
      .state('app.organization', {
        url: '/organization/list',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/organization/listOrganization.html',
            controller: 'ListOrganizationController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ORGANIZATION') };
          }
        }
      })
      .state('app.organization.details', {
        url: '/edit/:id/:create',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/organization/details/organizationDetails.html',
            controller: 'OrganizationDetailsController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate, $stateParams) {
            return {
              value:
                $stateParams.create === 'false'
                  ? $translate.instant('EDIT_ORGANIZATION')
                  : $translate.instant('CREATE_ORGANIZATION')
            };
          }
        }
      })
      .state('app.workingSchedules', {
        url: '/working-schedules',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/workingSchedulesAndHolidays/workingSchedulesAndHolidays.html',
            controller: 'WorkingSchedulesController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return {
              value: $translate.instant('WORKING_SCHEDULES')
            };
          }
        }
      })
      // .state('app.news', {
      //   url: '/news',
      //   views: {
      //     'layoutPageContainer@app': {
      //       templateUrl: 'app/news/news.html',
      //       controller: 'NewsController',
      //       controllerAs: 'vm'
      //     }
      //   },
      //   data: {
      //     displayName: '{{crumb.value}}'
      //   },
      //   resolve: {
      //     crumb: function ($translate) {
      //       return { value: $translate.instant('ASIDE_MENU_NEWS') }
      //     }
      //   }
      // })
      // .state('app.reports', {
      //   url: '/reports',
      //   views: {
      //     'layoutPageContainer@app': {
      //       templateProvider: [
      //         'brand',
      //         '$templateRequest',
      //         function (brand, $templateRequest) {
      //           var page;
      //           switch (brand) {
      //             case 'karcher':
      //               page = 'app/reportsKarcher/reportsKarcher.html';
      //               return $templateRequest(page);
      //             default:
      //               page = 'app/reportsBuilderKarcher/reportsBuilderKarcher.html';
      //               return $templateRequest(page);
      //           }
      //         }
      //       ],
      //       controllerProvider: [
      //         'brand',
      //         function (brand) {
      //           switch (brand) {
      //             case 'karcher':
      //               return 'ReportsKarcherController';
      //             default:
      //               return 'ReportsBuilderKarcherController';
      //           }
      //         }
      //       ],
      //       controllerAs: 'vm'
      //     }
      //   },
      //   data: {
      //     displayName: '{{crumb.value}}'
      //   },
      //   resolve: {
      //     crumb: function ($translate) {
      //       return { value: $translate.instant('ASIDE_MENU_REPORTS') };
      //     }
      //   }
      // })
      .state('app.reports', {
        url: '/reports',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/reportsBuilderKarcher/reportsBuilderKarcher.html',
            controller: 'ReportsBuilderKarcherController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_REPORTS') };
          }
        }
      })
      .state('app.cashlessSales', {
        url: '/cashless-sales',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/cashlessPaymentRefund/cashlessPaymentRefund.html',
            controller: 'CashlessPaymentRefundController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_CASHLESS_SALES') };
          }
        }
      })
      .state('app.reports.dailyTotal', {
        url: '/dailyTotal',
        views: {
          'reportDetails@app.reports': {
            templateUrl: 'app/reports/dailyTotalReport/dailyTotalReport.html',
            controller: 'dailyTotalReportController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_REPORT') };
          }
        }
      })
      .state('app.reports.dailyCoinsTotal', {
        url: '/dailyCoinsTotal',
        views: {
          'reportDetails@app.reports': {
            templateUrl: 'app/reports/dailyCoinsReport/dailyCoinsReport.html',
            controller: 'dailyCoinsReportController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_REPORT') };
          }
        }
      })
      .state('app.reports.dailyEuroKeyTotal', {
        url: '/dailyEuroKeyTotal',
        views: {
          'reportDetails@app.reports': {
            templateUrl:
              'app/reports/dailyEurokeyReport/dailyEurokeyReport.html',
            controller: 'dailyEuroKeyReportController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_REPORT') };
          }
        }
      })
      .state('app.reports.dailyR2WTotal', {
        url: '/dailyR2WTotal',
        views: {
          'reportDetails@app.reports': {
            templateUrl: 'app/reports/dailyR2WReport/dailyR2WReport.html',
            controller: 'dailyR2WReportController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_REPORT') };
          }
        }
      })
      .state('app.reports.comparation', {
        url: '/comparationReport',
        views: {
          'reportDetails@app.reports': {
            templateUrl: 'app/reports/comparationReport/comparationReport.html',
            controller: 'comparationReportController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_REPORT') };
          }
        }
      })
      .state('app.reports.avgByHour', {
        url: '/avgByHour',
        views: {
          'reportDetails@app.reports': {
            templateUrl: 'app/reports/avgByHourReport/avgByHourReport.html',
            controller: 'avgByHourReportController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_REPORT') };
          }
        }
      })
      .state('app.reports.avgByDay', {
        url: '/avgByDay',
        views: {
          'reportDetails@app.reports': {
            templateUrl: 'app/reports/avgByDayReport/avgByDayReport.html',
            controller: 'avgByDayReportController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_REPORT') };
          }
        }
      })
      .state('app.reports.avgByBox', {
        url: '/avgByBox',
        views: {
          'reportDetails@app.reports': {
            templateUrl: 'app/reports/avgByBoxReport/avgByBoxReport.html',
            controller: 'avgByBoxReportController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_REPORT') };
          }
        }
      })
      .state('app.reports.totalUsers', {
        url: '/totalUsers',
        views: {
          'reportDetails@app.reports': {
            templateUrl: 'app/reports/userGroupsByDate/userGroupsByDate.html',
            controller: 'userGroupsByDateController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_REPORT') };
          }
        }
      })
      .state('app.reports.totalVisits', {
        url: '/totalVisits',
        views: {
          'reportDetails@app.reports': {
            templateUrl:
              'app/reports/usersPerVisitReport/usersPerVisitReport.html',
            controller: 'usersPerVisitReportController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_REPORT') };
          }
        }
      })
      .state('app.reports.givenLoyalty', {
        url: '/totalSpentLocalTokensPerDay',
        views: {
          'reportDetails@app.reports': {
            templateUrl:
              'app/reports/givenLoyaltyPerDayReport/givenLoyaltyPerDayReport.html',
            controller: 'givenLoyaltyPerDayReportController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_REPORT') };
          }
        }
      })
      .state('app.reports.getTotalGivenLocalTokensPerDay', {
        url: '/totalGivenLocalTokensPerDay',
        views: {
          'reportDetails@app.reports': {
            templateUrl:
              'app/reports/totalGivenLocalTokensPerDay/totalGivenLocalTokensPerDay.html',
            controller: 'totalGivenLocalTokensPerDayReportController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_REPORT') };
          }
        }
      })
      .state('app.reports.getTotalPurchasedLocalTokensPerDay', {
        url: '/totalPurchasedLocalTokensPerDay',
        views: {
          'reportDetails@app.reports': {
            templateUrl:
              'app/reports/totalPurchasedLocalTokensPerDay/totalPurchasedLocalTokensPerDay.html',
            controller: 'totalPurchasedLocalTokensPerDayReportController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_REPORT') };
          }
        }
      })
      .state('app.reports.loyaltyPerPayment', {
        url: '/loyaltyPerPayment',
        views: {
          'reportDetails@app.reports': {
            templateUrl:
              'app/reports/loyaltyPerPaymentMethodReport/loyaltyPerPaymentMethodReport.html',
            controller: 'loyaltyPerPaymentMethodReportController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_REPORT') };
          }
        }
      })
      .state('app.reports.changerIncome', {
        url: '/changerIncome',
        views: {
          'reportDetails@app.reports': {
            templateUrl:
              'app/reports/changerIncomeByDate/changerIncomeByDate.html',
            controller: 'changerIncomeByDateController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_REPORT') };
          }
        }
      })
      .state('app.reports.posIncome', {
        url: '/posIncome',
        views: {
          'reportDetails@app.reports': {
            templateUrl: 'app/reports/totalIncomePos/totalIncomePos.html',
            controller: 'posIncomeReportController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_REPORT') };
          }
        }
      })
      .state('app.userGroups', {
        url: '/userGroups',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/userGroups/userGroups.html',
            controller: 'userGroupsController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_USER_GROUPS') };
          }
        }
      })
      .state('app.userGroups.new', {
        url: '/new?groupType',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/createUpdateUserGroup/createUpdateUserGroup.html',
            controller: 'createUpdateUserGroupController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('BREAD_CRUMBS_NEW_USER_GROUP') };
          }
        }
      })
      .state('app.userGroups.edit', {
        url: '/:id',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/createUpdateUserGroup/createUpdateUserGroup.html',
            controller: 'createUpdateUserGroupController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return {
              value: $translate.instant('BREAD_CRUMBS_EDIT_USER_GROUP')
            };
          }
        }
      })
      .state('app.loyalty', {
        url: '/loyalty',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/loyalty/loyalty.html',
            controller: 'LoyaltyController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_LOYALTY') };
          }
        }
      })
      .state('app.loyalty.newCampaign', {
        url: '/campaigns/new',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/createUpdateCampaign/createUpdateCampaign.html',
            controller: 'createUpdateCampaignController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('BREAD_CRUMBS_NEW_CAMPAIGN') };
          }
        }
      })
      .state('app.loyalty.editCampaign', {
        url: '/campaigns/:id',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/createUpdateCampaign/createUpdateCampaign.html',
            controller: 'createUpdateCampaignController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        params: {
          facilityType: null
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('BREAD_CRUMBS_EDIT_CAMPAIGN') };
          }
        }
      })
      .state('app.loyalty.newTemplate', {
        url: '/template/new',
        views: {
          'layoutPageContainer@app': {
            templateUrl:
              'app/createUpdateCampaignTemplate/createUpdateCampaignTemplate.html',
            controller: 'createUpdateCampaignTemplateController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return {
              value: $translate.instant('BREAD_CRUMBS_NEW_CAMPAIGN_TEMPLATE')
            };
          }
        }
      })
      .state('app.loyalty.editTemplate', {
        url: '/template/:id',
        views: {
          'layoutPageContainer@app': {
            templateUrl:
              'app/createUpdateCampaignTemplate/createUpdateCampaignTemplate.html',
            controller: 'createUpdateCampaignTemplateController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return {
              value: $translate.instant('BREAD_CRUMBS_EDIT_CAMPAIGN_TEMPLATE')
            };
          }
        }
      })
      // .state('app.periodicSummary', {
      //   url: '/periodicSummary',
      //   views: {
      //     'layoutPageContainer': {
      //       templateUrl: 'app/periodicSummary/periodicSummary.html',
      //       controller: 'periodicSummaryController',
      //       controllerAs: 'vm'
      //     }
      //   },
      //   data: {
      //     displayName: '{{crumb.value}}'
      //   },
      //   resolve: {
      //     crumb: function ($translate) {
      //       return { value: $translate.instant('BREAD_CRUMBS_PERIODIC_SUMMARY') }
      //     }
      //   }
      // })
      .state('app.errorPage', {
        url: '/errorPage',
        views: {
          errorPageContainer: {
            templateUrl: 'app/errorPage/errorPage.html',
            controller: 'ErrorPageController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ERROR_TITLE') };
          }
        }
      })
      .state('app.errorPageWithRedirectToDashboard', {
        url: '/errorPageBadRequest',
        views: {
          errorPageContainer: {
            templateUrl: 'app/errorPage/redirectToDashboard/redirectToDashboard.html',
            controller: 'errorPageWithRedirectToDashboardController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ERROR_TITLE') };
          }
        }
      })
      .state('app.accountManagement', {
        url: '/accountManagement',
        views: {
          layoutPageContainer: {
            templateUrl: 'app/accountManagement/accountManagement.html',
            controller: 'AccountManagementController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ACCOUNT_MANAGEMENT') };
          },
          isValidUser: function (checkUserRole) {
            return (
              checkUserRole.isAdministrator() || checkUserRole.isMerchantAdmin()
            );
          }
        }
      })
      .state('app.accountManagement.user', {
        url: '/user/:userId',
        views: {
          'layoutPageContainer@app': {
            templateUrl:
              'app/accountManagement/userOrganization/userOrganization.html',
            controller: 'UserOrganizationController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('USER_ORGANIZATION') };
          }
        }
      })
      .state('app.releaseNotes', {
        url: '/release-notes',
        views: {
          layoutPageContainer: {
            templateUrl: 'app/releaseNotes/releaseNotes.html',
            controller: 'ReleaseNotesController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('RELEASE_NOTES') };
          }
        }
      })
      .state('app.periodicSummary', {
        url: '/periodicSummary',
        views: {
          layoutPageContainer: {
            templateUrl: 'app/periodicSummary/periodicSummary.html',
            controller: 'periodicSummaryController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return {
              value: $translate.instant('BREAD_CRUMBS_PERIODIC_SUMMARY')
            };
          }
        }
      })
      .state('app.vouchers', {
        url: '/vouchers',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/vouchers/vouchers.html',
            controller: 'VouchersController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_VOUCHERS') };
          }
        }
      })
      .state('app.transactions', {
        url: '/transactions',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/transactions/transactions.html',
            controller: 'TransactionsController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_TRANSACTIONS') };
          }
        }
      })
      .state('app.tokens', {
        url: '/tokens',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/managingTokens/managingTokens.html',
            controller: 'ManagingTokensController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('MANAGING_TOKENS') };
          }
        }
      })
      .state('app.pricing', {
        url: '/pricing',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/pricing/pricing.html',
            controller: 'PricingController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('PRICING') };
          }
        }
      })
      .state('app.savings', {
        url: '/savings',
        params: {
          tab: null
        },
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/savings/savings.html',
            controller: 'SavingsController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_SAVINGS') };
          }
        }
      })
      .state('app.savingsCreate', {
        url: '/savings/create',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/savings/savingsCreate.html',
            controller: 'SavingsCreateController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('SAVINGS_CREATE_TITLE') };
          }
        }
      })
      .state('app.savingsGroupCreate', {
        url: '/savings/groups/new',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/savings/savingsGroupCreate.html',
            controller: 'SavingsGroupCreateController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('SAVINGS_CREATE_GROUP') };
          }
        }
      })
      .state('app.savingsGroupEdit', {
        url: '/savings/groups/:id/edit',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/savings/savingsGroupCreate.html',
            controller: 'SavingsGroupCreateController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('BREAD_CRUMBS_EDIT_USER_GROUP') };
          }
        }
      })
      .state('app.savingsEdit', {
        url: '/savings/edit/:accountId',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/savings/savingsEdit.html',
            controller: 'SavingsEditController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('SAVINGS_EDIT_TITLE') };
          }
        }
      })
      .state('app.savingsGroupDetails', {
        url: '/savings/group/:groupId',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/savings/savingsGroupDetails.html',
            controller: 'SavingsGroupDetailsController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('SAVINGS_GROUP_DETAILS') };
          }
        }
      })
      .state('app.moneyChangerJournal', {
        url: '/money-changer-journal',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/moneyChangerJournal/moneyChangerJournal.html',
            controller: 'MoneyChangerJournalController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_MONEY_CHANGER_JOURNAL') };
          },
          isValidUser: function (checkUserRole) {
            return checkUserRole.isMerchantAdmin();
          }
        }
      })
      .state('app.rollover', {
        url: '/rollover?showList',
        params: {
          showList: null
        },
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/rollover/rollover.html',
            controller: 'RolloverController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_ROLLOVER') };
          },
          isValidUser: function (checkUserRole) {
            return checkUserRole.isMerchantAdmin() || checkUserRole.isCashier();
          }
        }
      })
      .state('app.rolloverPrograms', {
        url: '/rollover/site/:siteId/createVoucher',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/rollover/rolloverPrograms.html',
            controller: 'RolloverProgramsController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ROLLOVER_PROGRAM_SELECTION') };
          },
          isValidUser: function (checkUserRole) {
            return checkUserRole.isMerchantAdmin() || checkUserRole.isCashier();
          }
        }
      })
      .state('app.rolloverSalesTypes', {
        url: '/rollover/sales-types',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/rollover/rolloverSalesTypes.html',
            controller: 'RolloverSalesTypesController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ROLLOVER_SALES_TYPES') };
          },
          isValidUser: function (checkUserRole) {
            return checkUserRole.isMerchantAdmin();
          }
        }
      })
      // .state('app.rolloverVouchersReport', {
      //   url: '/rollover/vouchers-report',
      //   views: {
      //     'layoutPageContainer@app': {
      //       templateUrl: 'app/rolloverVouchersReport/rolloverVouchersReport.html',
      //       controller: 'RolloverVouchersReportController',
      //       controllerAs: 'vm'
      //     }
      //   },
      //   data: {
      //     displayName: '{{crumb.value}}'
      //   },
      //   resolve: {
      //     crumb: function ($translate) {
      //       return { value: $translate.instant('ROLLOVER_VOUCHERS_REPORT') };
      //     },
      //     isValidUser: function (checkUserRole) {
      //       return checkUserRole.isMerchantAdmin() || checkUserRole.isCashier();
      //     }
      //   }
      // })
      // .state('app.rolloverStatistics', {
      //   url: '/rollover/site/:siteId/statistics',
      //   views: {
      //     'layoutPageContainer@app': {
      //       templateUrl: 'app/rollover/rolloverStatistics.html',
      //       controller: 'RolloverStatisticsController',
      //       controllerAs: 'vm'
      //     }
      //   },
      //   data: {
      //     displayName: '{{crumb.value}}'
      //   },
      //   resolve: {
      //     crumb: function ($translate) {
      //       return { value: $translate.instant('STATISTICS') };
      //     },
      //     isValidUser: function (checkUserRole) {
      //       return checkUserRole.isMerchantAdmin();
      //     }
      //   }
      // })
      .state('app.help', {
        url: '/help',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/knowledgeBase/knowledgeBase.html'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('HELP') };
          }
        }
      })
  .state('app.termsAndService', {
      url: '/terms-and-service/:marker',
      views: {
        'layoutPageContainer@app': {
          templateUrl: 'app/knowledgeBase/termsAndService.html',
          controller: 'TermsAndServiceController',
          controllerAs: 'vm'
        }
      },
      data: {
        displayName: '{{crumb.value}}'
      },
      resolve: {
        crumb: function ($translate) {
          return { value: $translate.instant('TERMS_AND_SERVICES') };
        }
      }
    });

    $urlRouterProvider.otherwise('/login');
    // $locationProvider.html5Mode(true);
  }
})();
